"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.upgrade.subject': 'Account Upgraded Successfully',
    'email.upgrade.title': 'Your Account Has Been Upgraded!',
    'email.upgrade.text': 'Great news! Your account has been successfully upgraded and you now have access to enhanced features.',
    'email.upgrade.new_plan': 'New Plan',
    'email.upgrade.benefits': 'You can now enjoy all the benefits of your new subscription plan.',
    'email.upgrade.dashboard_button': 'Go to Dashboard',
    'email.upgrade.footer': 'Thank you for choosing IntHub!',
};
